import { render, staticRenderFns } from "./VariableChooser.vue?vue&type=template&id=ba05ad0a&"
import script from "./VariableChooser.vue?vue&type=script&lang=ts&"
export * from "./VariableChooser.vue?vue&type=script&lang=ts&"
import style0 from "./VariableChooser.vue?vue&type=style&index=0&id=ba05ad0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports